<template>
  <div>
    <!-- <div v-if="type === '0'" class="round light">light</div> -->
    <!-- <div v-else-if="type === '1'" class="round standard">stand</div> -->
    <div v-if="type === '2'" class="round large">large</div>
    <!-- <div v-else class="round unknown">unknown</div> -->
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'unknown',
    }
  },
};
</script>

<style>
.round {
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  text-align: center;
  font-size: small;
  display: inline-block;
  /* padding-left: 0.5rem;
  padding-right: 0.5rem; */
  width: 100%;
}
.light {
  background-color: darkgreen;
  color: white;
}
.standard {
  background-color: deepskyblue;
  color: white;
}
.large {
  background-color: crimson;
  color: white;
}
.unknown {
  background-color: dimgray;
  color: white;
}
</style>
